import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AggregationAnalysisTablePage from './AggregationAnalysisTablePage';
import AggregationJobsPage from './AggregationJobsPage';
import InsightDetailPage from './InsightDetailPage';
import SchedulerSettingsPage from './SchedulerSettingsPage';

/**
 * Router component that switches between different analysis views based on URL parameter
 * Use ?view=jobs to show the jobs management page
 * Use ?view=insight&jobId=...&insightId=... to show insight detail page
 * Use ?view=scheduler to show scheduler settings
 * Default is the table view
 */
const AggregationAnalysisPageRouter = () => {
  const [searchParams] = useSearchParams();
  const viewMode = searchParams.get('view');

  // If view=jobs parameter is present, show jobs management page
  if (viewMode === 'jobs') {
    return <AggregationJobsPage />;
  }
  
  // If view=insight parameter is present, show insight detail page
  if (viewMode === 'insight') {
    return <InsightDetailPage />;
  }
  
  // If view=scheduler parameter is present, show scheduler settings page
  if (viewMode === 'scheduler') {
    return <SchedulerSettingsPage />;
  }
  
  // Default to card view
  return <AggregationAnalysisTablePage />;
  
};

export default AggregationAnalysisPageRouter;

